<template>
  <div class="word-unit dialog">
    <match-info
      v-if="course.subject_group === 'vocabulary' || course.courseType === 'vocabulary'"
      :is-show-board="true" />
    <div class="content">
      <div
        class="close"
        @click="onClose"
        ></div>
      <div class="title">{{course.name}}</div>
      <div class="main">
        <div class="unit-list-wrapper">
          <div class="unit-list">
            <div
              class="unit"
              :class="{ 'active': unit.id === currentUnit.id }"
              v-for="(unit, index) in unitList"
              :key="unit.id"
              @dblclick="start('bdc_learn')"
              @click="selectUnit(unit)">
              <span class="experience" v-if="unit.isExperienceUnit">快速体验</span>
              <div class="label">
                <div class="number">{{index + 1}}</div>
              </div>
              <div class="unit-info">
                <div class="word-name" :title="unit.name">{{ unit.name }}</div>
                <div class="word-number">
                  <span>单词数&nbsp;</span>
                  <span>{{unit.completeWordCount}} / {{unit.wordCount}}</span>
                </div>
                <div class="test-number">
                  学前测试&nbsp;{{computedScore(unit.beforeScore)}}&nbsp;&nbsp;
                  学后测试&nbsp;{{computedScore(unit.afterScore)}}
                </div>
              </div>
            </div>
          </div>
            <div class="control">
              <span>本单元学习进度</span>
              <el-progress
                class="progress"
                color="#5256e6"
                :percentage="currentUnit.progress">
              </el-progress>
              <div
                class="btn btn-primary btn-circle"
                @click="start('bdc_learn')">开始学习</div>
            </div>
        </div>
        <div class="word-test">
          <div
            class="item">
            <div class="name-wrapper">
              <div class="name">智能测试</div>
              <div class="describe">已学习单词测试</div>
            </div>
            <div
              class="btn btn-primary btn-circle"
              @click="onChange('wordExam')">开始测试
            </div>
          </div>
          <div class="item">
            <div class="name-wrapper">
              <div class="name">本书测试</div>
              <div class="describe">本书单词测试</div>
            </div>
            <div
              @click="start('bdc_book_exam')"
              class="btn btn-primary btn-circle">开始测试</div>
          </div>
          <div class="item">
            <div class="name-wrapper">
              <div class="name">一测到底</div>
              <div class="describe">所有单词测试</div>
            </div>
            <div
              @click="start('bdc_all_exam')"
              class="btn btn-primary btn-circle">开始测试</div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      ref="notAvailable"
      append-to-boby
      moda-aAppend-today
    >
      <div class="title" slot="title">体验结束</div>
      <div class="not-available">
        <p>你表现的太好啦！</p>
        <p>现在停止学习太可惜啦，快联系老师为您开卡继续学习吧！</p>
        <p>使用期间您有任何疑问，请联系相关运营人员。</p>
        <el-button
          @click="closeNotAvailable(item)"
        >
          知道啦
        </el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Progress } from 'element-ui';
import MatchInfo from '@/components/match/MatchInfo.vue';
import api from '@/api/graphql/course';
import utils from '@/services/utils';
import VanDialog from '@/components/common/Dialog.vue';

export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ElProgress: Progress,
    MatchInfo,
    VanDialog,
  },
  computed: {
    isFinished() {
      return this.unitList.every(item => item.progress === 100);
    },
  },
  data() {
    return {
      unitList: [],
      currentUnit: {},
    };
  },
  created() {
    if (this.course.id) {
      this.fetchUnitList(this.course.id);
    }
  },
  methods: {
    onClose() {
      this.$emit('close', {
        scene: 'selectCourse',
      });
    },
    onChange(scene) {
      this.$emit('change', {
        scene,
        params: {
          course: this.course,
          unit: this.currentUnit,
        },
      });
    },
    fetchUnitList(courseId) {
      api.getWordUnitList({
        courseId,
      }).then(({ wordUnitList }) => {
        const [first] = wordUnitList;
        let unit = null;

        for (let i = 0; i < wordUnitList.length; i += 1) {
          const element = wordUnitList[i];
          if (element.progress < 100) {
            unit = element;
            break;
          }
        }

        this.currentUnit = unit || first;
        this.unitList = wordUnitList;
      });
    },
    computedScore(score) {
      return score === -1 ? '暂无' : `${score}分`;
    },
    closeNotAvailable() {
      this.$refs.notAvailable.close();
    },
    selectUnit(unit) {
      if (!unit.isAvailable) {
        this.$refs.notAvailable.open();
        return;
      }
      this.currentUnit = unit;
    },
    start(type) {
      if ((type === 'bdc_book_exam' || type === 'bdc_all_exam') && !this.isFinished) {
        utils.error('请先完成本书的学习再来进行整体测试哦！');
        return;
      }
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          course: this.course,
          unit: this.currentUnit,
          type,
        },
      });
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .not-available {
    text-align: center;
    color: $primary-light;
    font-size: $font-size-lg;
    font-weight: bold;
    button {
      background: $primary-light;
      color: #fff;
      border-radius: 8px;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import "@/styles/common/dialog.scss";

  .word-unit {
    width: 130vh;
    height: 90vh;
    transform: none;
    .content {
      display: flex;
      flex-direction: column;
      .title {
        padding: 20px 0 20px 20px;
        font-size: 2.4vh;
      }
      .main {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .unit-list-wrapper {
          background: #fff;
          border-radius: 20px;
          .unit-list {
            position: relative;
            display: flex;
            align-content: flex-start;
            flex-wrap: wrap;
            box-sizing: border-box;
            padding: 1.85vh 1.85vh 2vh;
            width: 100%;
            height: 55vh;
            overflow-y: auto;
            background: #fff;
            border-radius: 20px;
            .unit {
              position: relative;
              margin: 10px 2% 10px 0;
              display: flex;
              align-items: center;
              width: 30%;
              height: 11.4vh;
              overflow: hidden;
              background: #EDEBFB;
              border-radius: 20px;
              cursor: pointer;
              &:hover {
                transform: scale(1.02);
              }
              &.active {
                background: $primary;
                .label {
                  background: #fff;
                  color: #18435C;
                }
                .unit-info {
                  color: #fff;
                }
              }
              .experience {
                position: absolute;
                right: 8px;
                top: 6px;
                background-color: #e9f7fe;
                color: #4190f7;
                font-size: 12px;
                padding: 2px;
                border-radius: 5px;
              }
              .label {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-left: 1.85vh;
                width: 7.6vh;
                height: 7.6vh;
                background: $primary;
                border-radius: 10px;
                .tag {
                  font-size: 1.8vh;
                  font-weight: 700;
                }
                .number {
                  font-size: 4vh;
                  font-weight: 700;
                }
              }
              .unit-info {
                width: 65%;
                margin-left: 1.2vh;
                color: #18435C;
                font-size: 1.6vh;
                font-weight: 700;
                .word-name {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 2.2vh;
                }
                .word-number {
                  margin: 1vh 0 1vh 0;
                }
              }
            }
          }
          .control {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto 10px;
            width: calc(100% - 3.7vh);
            color: #18435C;
            font-weight: 700;
            .progress {
              margin-left: 10px;
              flex: 1;
            }
            .btn {
              padding: 8px 18px;
              font-size: 2.3vh;
            }
          }
        }
        .word-test {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
          .item {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 39vh;
            height: 19vh;
            background: #fff;
            border-radius: 24px;
            .name-wrapper {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: relative;
              box-sizing: border-box;
              // margin-left: 1.38vh;
              // padding-top: 1.38vh;
              height: 12vh;
              font-weight: 700;
              .name {
                color: #18435C;
                font-size: 3vh;
                font-weight: 700;
              }
              .describe {
                margin-top: 5px;
                font-size: 1.8vh;
                color: #a9a7a7;
              }
            }
            .btn {
              width: 13vh;
              height: 5.3vh;
              font-size: 2.28vh;
              line-height: 5.3vh;
              text-align: center;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
</style>
